import React, { Fragment, useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { allFiltersSelector, liveModeSelector } from '@store/metricLens/base/selectors';
import filterContainerSelector from '@store/filterContainer/selectors';
import { changeFilterContainerVisibility } from '@store/filterContainer/actions';
import Filter from './Filter';
import FilterContainer from './FilterContainer';
import NewFilter from './NewFilter';
import { StyledFilterWrapper, ModalMask } from './styled';
import { fetchData } from '@store/metricLens/liveData/actions';
import { NOC_REFRESH_INTERVAL } from '@utils/constants';
import { checkIfBrowserTabIsVisible } from '@src/hooks/useBrowserTabVisibility';
// eslint-disable-next-line react/display-name
export default () => {
  const parentRef = useRef(null);
  const allFilters = useSelector(allFiltersSelector);
  const dispatch = useDispatch();
  const liveMode = useSelector(liveModeSelector);
  const filterContainer = useSelector(filterContainerSelector);
  const [position, setPosition] = useState(null);
  const [activeFilter, setActiveFilter] = useState(0);

  const onFilterOpen = (index) => {
    setActiveFilter(index);
    setPosition(parentRef.current.children[index].getBoundingClientRect());
    dispatch(changeFilterContainerVisibility(true));
  };

  useEffect(() => {
    if (liveMode) {
      dispatch(fetchData());
    }
  }, [liveMode, dispatch]);

  useEffect(() => {
    let interval: any = null;

    if (liveMode) {
      interval = setInterval(() => {
        if (checkIfBrowserTabIsVisible()) {
          dispatch(fetchData());
        }
      }, NOC_REFRESH_INTERVAL);
    } else {
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [liveMode, dispatch, allFilters]);

  return (
    <div ref={parentRef}>
      {allFilters.map((eachFilter, index) => (
        <Filter
          filter={eachFilter}
          key={`random-${JSON.stringify(eachFilter)}-${liveMode}`}
          index={index}
          filterLength={allFilters.length}
          onFilterOpen={onFilterOpen}
          liveMode={liveMode}
        />
      ))}
      <NewFilter
        setActiveFilter={setActiveFilter}
        setPosition={setPosition}
        allFilters={allFilters}
        parentRef={parentRef}
      />
      {filterContainer.visible ? (
        <Fragment>
          <ModalMask id="modal" />
          <StyledFilterWrapper position={position}>
            <FilterContainer activeFilter={activeFilter} appliedFilter={allFilters[activeFilter]} />
          </StyledFilterWrapper>
        </Fragment>
      ) : null}
    </div>
  );
};
